import React, { useState } from 'react'
import categories from '../categorybutton/categories.js'

import './styles.scss'

import firebase from "firebase";
import "firebase/database";
// require('firebase/database')

const config = {
  databaseURL: 'https://zurich-liefert.firebaseio.com'
}

firebase.initializeApp(config)

function Form() {

  const [showError, setShowError] = useState(false)
  const [formSent, setFormSent] = useState(false)
  const [content, setContent] = useState({
      position: [],
      category: '',
      title: '',
      description: '',
      contact: '',
      street: '',
      place: '',
      phone: '',
      email: '',
      name: '',
      timestamp: Date.now()
    })

  const onChange = e => {
    const c = { ...content }
    c[e.target.name] = e.target.value
    setContent(c)
  }

  const validateForm = () => {
    let error = false
    error = content.title.length === 0 ? true : error
    error = content.description.length === 0 ? true : error
    error = content.street.length === 0 ? true : error
    error = content.place.length === 0 ? true : error
    error = content.contact.length === 0 ? true : error
    error = content.name.length === 0 ? true : error
    error = content.email.length === 0 ? true : error
    error = content.category.length === 0 ? true : error

    if (error) {
      setShowError(true)
    } else {
      setFormSent(true)
    }
  }

  React.useEffect(() => {
    if (formSent === true) {
      const newPostKey = firebase
        .database()
        .ref()
        .child('data')
        .push().key

      firebase
        .database()
        .ref('/data/' + newPostKey)
        .update(content)
        .then(() => {
          console.log('Writing done')
        })
        .catch(e => {
          console.log('error', e)
        })
    }
  }, [formSent])  


  return (

    <div id='formcontent' className='ui vertical segment'>
    {!formSent && (
      <div className='ui text container formcontainer'>
        <div className='ui form'>
            <h4 className='ui horizontal divider header'>
            Öffentliche Angaben
            </h4>
            <p>
            Folgende Angaben werden auf der Karte publiziert. Schreiben Sie
            also nur jene Angaben hin, die auch publiziert werden dürfen.
            </p>

            <div className='field'>
            <label>Art Ihres Unternehmens</label>
            <select
                value={content.category}
                className='ui dropdown'
                onChange={e =>
                setContent({ ...content, category: e.target.value })
                }
            >
                <option value='' />
                {categories.map(c => (
                <option value={c.ident} key={c.ident}>
                    {c.text}
                </option>
                ))}
            </select>
            </div>

            <div className='field required'>
              <label>Name des Unternehmens</label>
              <input
                  type='text'
                  name='title'
                  value={content.title}
                  onChange={onChange}
                  placeholder='Bäckerei Müller'
              />
            </div>
            
            <div className='field required'>
              <label>Strasse</label>
              <input
                  type='text'
                  name='street'
                  value={content.street}
                  onChange={onChange}
                  placeholder='Hauptstrasse 27'
              />
            </div>
            
            <div className='field required'>
              <label>PLZ und Ort</label>
              <input
                  type='text'
                  name='place'
                  value={content.place}
                  onChange={onChange}
                  placeholder='8400 Winterthur'
              />
            </div>

            <div className='field required'>
            <label>Diese Dienstleistungen bieten Sie an.</label>
            <textarea
                rows={4}
                name='description'
                onChange={onChange}
                placeholder='Schreiben Sie hier in einigen Sätzen, was der Kunde bei Ihnen bestellen kann.'
                defaultValue={content.description}
            />
            </div>

            <div className='field required'>
            <label>So kann man diese Dienstleistung beziehen</label>
            <textarea
                rows={4}
                name='contact'
                placeholder='Website, Telefon, E-Mail-Adresse...'
                defaultValue={content.contact}
                onChange={onChange}
            />
            </div>

            <h4 className='ui horizontal divider header'>
            Administrative Angaben
            </h4>
            <p>
            Diese Angaben werden wir nicht publizieren. Wir nutzen diese
            nur, falls wir Sie kontaktieren müssen.
            </p>

            <div className='field required'>
            <label>Ihr Name</label>
            <input
                type='text'
                name='name'
                placeholder='Max Mustermann'
                defaultValue={content.name}
                onChange={onChange}
            />
            </div>

            <div className='field required'>
            <label>Ihre E-Mail-Adresse</label>
            <input
                type='text'
                name='email'
                placeholder='kontakt@bäckerei-müller.ch'
                defaultValue={content.email}
                onChange={onChange}
            />
            </div>

            <div className='field'>
            <label>Telefonnummer (freiwillig)</label>
            <input
                type='text'
                name='phone'
                placeholder='079...'
                defaultValue={content.phone}
                onChange={onChange}
            />
            </div>

            {showError && (
            <div className='ui negative message'>
              <div className='header'>Fehlende Angaben</div>
              <p>
              Bitte füllen Sie alle erforderten Formularfelder aus. Danke!
              </p>
            </div>
            )}

            <div className='ui buttons'>
              <button className='ui positive button' onClick={validateForm}>
                Formular abschicken
              </button>
            </div>
        </div>
      </div>
    )}
      {formSent && (
        <div className='ui vertical segment'>
          <div className='ui text container'>
            <div className='ui success message'>
              <div className='header'>Vielen Dank!</div>
              <p>
                Ihre Daten wurden gespeichert. Wir werden ihre Angaben nach der Prüfung publizieren.
              </p>
            </div>
          </div>
        </div>
      )}      
    </div>    

  )
}

export default Form
